import { pdf } from '@react-pdf/renderer'
import type { Resume } from '../types'
import { buildResumeFilename } from './resumeBuilder'
import { resumeDocumentFor } from '../components/resumeBuilder/templates'

/**
 * Generate a PDF Blob for the given resume using its selected template.
 */
export async function renderResumePdf(resume: Resume): Promise<Blob> {
  const doc = resumeDocumentFor(resume)
  return await pdf(doc).toBlob()
}

/**
 * Trigger a browser download of the resume PDF.
 */
export async function downloadResumePdf(resume: Resume): Promise<void> {
  const blob = await renderResumePdf(resume)
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = buildResumeFilename(resume)
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  // Revoke shortly after to let the browser start the download
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
